import { render, staticRenderFns } from "./ClienteFormCaracteristica.vue?vue&type=template&id=5d1be8ce&scoped=true&"
import script from "./ClienteFormCaracteristica.vue?vue&type=script&lang=js&"
export * from "./ClienteFormCaracteristica.vue?vue&type=script&lang=js&"
import style0 from "./ClienteFormCaracteristica.vue?vue&type=style&index=0&id=5d1be8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1be8ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VTextField})
